
const VIDEO_MIME_TYPES = [
    'video/mp4',
    'video/quicktime',
    'video/mpeg',
    'video/x-flv',
    'video/x-msvideo',
    'video/x-ms-wmv',
    'video/x-ms-asf',
    'video/webm',
    'video/ogg',
];

const VIDEO_EXTENSIONS = [
    'mp4',
    'm1v',
    'mpg',
    'mov',
    'flv',
    'avi',
    'wmv',
    'asf',
    'webm',
    'ogg',
];

const VIDEO_MAX_SIZE = 500 * 1024 * 1024;

export {
    VIDEO_MIME_TYPES,
    VIDEO_EXTENSIONS,
    VIDEO_MAX_SIZE,
};
